import './StripeButton.css';

let stripe = window.Stripe('pk_live_51Hk6UwJxy5rDjwQaZ5LWa0DUT7hEHtUSLmhIbpEhdBHgca78bNhi4rxoGfe5slrOjivXL7fd67FoB1gLkdPNR2jt00wy2XPRnc');

 export let quantity;
 export let name;

 async function startCheckout(){
   const {error} = await stripe.redirectToCheckout({
    lineItems: [
        // Replace with the ID of your price
        {price: 'price_1Hk8Z1Jxy5rDjwQa6F0q0LTD', quantity: 1},
      ],
     mode: 'payment',
     successUrl:'https://natural-seducer.web.app/download12365hgf8469475qopeldnsjdedsdd18z4f5ezfezdz54sz98d4dsqdfe846', // Change When Deploying
     cancelUrl:'https://natural-seducer.web.app/canceled', // Change When Deploying
   })

   if(error){
     alert('Our payment system has encountered an issue !')
   }
 }

function StripeButton(){
    return(

        <>
        
        <button id="stripeBtn" class="button is-info" onClick={startCheckout}>Pay with Credit Card</button>
       
        </>

    );
}

export default StripeButton;